export default {"src":"/_next/static/media/splash.2e8d7307.svg","height":525,"width":499,"blurWidth":0,"blurHeight":0};